import styled from 'styled-components';
import {
  tablet_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const FeaturedArticlesStyles = styled.div`
  .featured-articles-cards {
    a:link,
    a:visited,
    a:hover,
    a:active {
      color: ${Colors.primary.black.standard};
      display: none;
      text-align: center;
      text-decoration: none;

      &.selected {
        display: block;
      }
      h4 {
        font-family: 'source-sans-pro', sans-serif;
        line-height: 28px;
        min-height: 85px;
      }
      h6 {
        color: ${Colors.accent.grey2.standard};
        margin: 10px 0;
      }
    }
  }

  .featured-articles-media {
    display: flex;
    height: 300px;
    justify-content: center;
    overflow: hidden;
    position: relative;

    a {
      align-items: center;
      display: flex;
      justify-content: center;
      position: relative;
      width: 100%;
    }
    img {
      height: 100%;
      min-width: 630px;
      object-fit: cover;
    }

    .featured-media-title {
      background: ${Colors.primary.claytonBlue.standard};
      bottom: 0;
      display: flex;
      color: #ffffff;
      flex-direction: column;
      justify-content: center;
      left: 0;
      padding: 25px;
      position: absolute;
      text-align: center;
      width: 100%;
    }
  }

  .featured-articles-dots {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;

    .dot {
      background-color: ${Colors.accent.grey4.standard};
      border-radius: 10px;
      margin: 5px;
      height: 7px;
      width: 7px;

      &.selected {
        background-color: ${Colors.primary.claytonBlue.standard};
        height: 11px;
        width: 11px;
      }
    }
  }

  .navigation {
    align-items: center;
    border: 1px solid ${Colors.accent.grey4.standard};
    border-radius: 50px;
    display: flex;
    justify-content: center;
    height: 40px;
    margin: 5px;
    transition: background-color 400ms ease 0s;
    width: 40px;

    svg {
      margin-left: 9px;
      margin-top: 10px;
    }

    &.right {
      svg {
        margin-left: 11px;
      }
    }

    &:hover {
      background-color: ${Colors.primary.claytonBlue.standard};
      cursor: pointer;

      svg * {
        fill: ${Colors.primary.white.standard};
      }
    }
  }

  @media screen and (min-width: ${tablet_breakpoint}px) {
    .featured-articles-media {
      height: 350px;
    }
    .featured-articles-cards {
      min-height: 75px;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    display: flex;
    flex-direction: row;

    .featured-articles-cards {
      align-content: center;
      display: flex;
      flex-direction: column;
      height: 550px;
      padding-left: 25px;
      width: 40%;

      a:link,
      a:visited,
      a:hover,
      a:active {
        display: flex;
        flex-direction: column;
        height: 33%;
        justify-content: center;
        text-align: left;

        &.selected {
          display: flex;
        }
        &:not(:last-child) {
          border-bottom: 1px solid ${Colors.accent.grey5.standard};
        }

        &:not(.selected) {
          h4 {
            opacity: 0.5;
          }
        }

        h4 {
          max-height: 115px;
          overflow: hidden;
        }
      }
    }

    .featured-articles-media {
      height: 550px;
      width: 60%;

      a {
        width: 100%;
      }
    }
    .featured-articles-dots {
      display: none;
    }
  }
`;
